import {
  CircularProgress,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
  styled,
  tableCellClasses,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ErrorAlert } from '../../components/atoms/Alert-message';
import Button from '../../components/atoms/button';
import InputTextAreaField from '../../components/atoms/input-field/inputTextAreaField';
import InputTextField from '../../components/atoms/input-field/inputTextField';
import PickDate from '../../components/atoms/pick-date';
import Toast, {
  showToasterFailure,
  showToasterSuccess,
} from '../../components/atoms/toast';
import { APIHeader } from '../../index';
import { errorNotification } from '../../reducers/handle-api-status/slice';
import {
  GlobalSiteTable,
  LocalSiteButtons,
  OwnerLSCComment,
  ReviewDoneMessage,
  SiteReviewTitle,
  SiteReviewValue,
  boldFont,
  checkboxLabel,
  commentStyle,
  homeButtonComponent,
  GCValue,
  titleName,
  TextAsLink,
  validationErrorOnPages,
  buttonCircularProgress,
} from '../../styles';
import {
  duplicates,
  findUnique,
  getDownloadLink,
  getURL,
  includeNegativeForCostImpact,
  isEmptyObject,
  keyMapper,
  stripTrailingSlash,
  validateInputFields,
} from '../../utils';

const GlobalCoordinatorReview = props => {
  const { apiConfig, userInfo, errorInAPI } = props;
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const urlInfo = stripTrailingSlash(window.location.toString()).split('/');
  const pecrId = urlInfo.pop();
  const url = getURL();

  const [globalData, setGlobalData] = useState([]);
  const [filterDataWithDepartment, setFilterDataWithDepartment] = useState([]);
  const [comment, setComment] = useState('');
  const [disabled, setDisabled] = useState(false);
  const [disabledButton, setDisabledButton] = useState(false);
  const [fetchedFiles, setFetchedFiles] = useState([]);
  const [isHold, setIsHold] = useState(false);
  const [GCValidUser, setGCValidUser] = useState({});
  const [inputValidationMessage, setInputValidationMessage] = useState('');
  const [showSaveProgress, setShowSaveProgress] = useState(false);
  const [disableRejectHold, setdisableRejectHold] = useState(false);

  useEffect(() => {
    if (pecrId) {
      //getting the global data from API
      fetch(`${apiConfig.uiURL}api/FetchGlobalCoordinatorReview`, {
        method: 'POST',
        headers: APIHeader(),
        body: JSON.stringify({
          pecrId: pecrId,
        }),
      })
        .then(async response => {
          const data = await response.json();
          setGlobalData(data);
          //To get the User who is assigned as Site Coordinator for particular PECR/Site
          //Page will be accessible to validLSCUser only
          const GlobalCoordinatorId =
            data.length > 0 &&
            data[1] &&
            data[1].find(item => {
              return item.GlobalCoordinator;
            });
          setGCValidUser(GlobalCoordinatorId);
          setComment(GlobalCoordinatorId.GCComments);

          // filter those data from global data which has deprtment
          const filterData = data[0].filter(item => {
            return item.Department !== null;
          });
          setFilterDataWithDepartment(filterData);

          //fectching files for those who has department
          filterData.map(async item => {
            const response = await fetch(
              `${apiConfig.uiURL}api/FetchFilesFromDepartment`,
              {
                method: 'POST',
                headers: APIHeader(),
                body: JSON.stringify({
                  MainFolder: 'PECROverview',
                  SubFolder: pecrId,
                  siteId: item.SiteID,
                  departmentId: item.DeptID,
                  index: item.EIndex,
                }),
              }
            ).catch(() => {
              dispatch(
                errorNotification({
                  hasErrorOccured: true,
                  message: t('error_message'),
                })
              );
            });
            const data2 = await response.json();
            setFetchedFiles(prevState => [
              ...prevState,
              {
                documents: data2,
                departmentId: item.DeptID,
                index: item.EIndex,
                siteId: item.SiteID,
              },
            ]);
          });
          const shouldDisableButton = data[1].every(item => {
            return (
              item.Status.includes('Reject') ||
              item.Status.includes('Submitted') ||
              item.Status.includes('NotImpacted')
            );
          });
          if (shouldDisableButton) {
            setDisabledButton(false);
          } else {
            setDisabledButton(true);
          }

          const shouldDisableRejectHold = data[1].some(item => {
            return (
              item.Status.includes('Reject') ||
              item.Status.includes('Submitted') ||
              item.Status.includes('NotImpacted')
            );
          });
          if (shouldDisableRejectHold) {
            setdisableRejectHold(false);
          } else {
            setdisableRejectHold(true);
          }
          const isReviewDone = data[1].every(item => {
            return (
              item.Status.includes('GC') || item.Status.includes('NotImpacted')
            );
          });
          if (isReviewDone) {
            setDisabled(true);
          } else {
            setDisabled(false);
          }
          const isSiteOnHold =
            data &&
            data.length > 0 &&
            data[1].some(item => {
              return item.GCStatus === 9;
            });
          if (isSiteOnHold) {
            setIsHold(true);
          } else {
            setIsHold(false);
          }
        })
        .catch(() => {
          dispatch(
            errorNotification({
              hasErrorOccured: true,
              message: t('error_message'),
            })
          );
        });
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pecrId, apiConfig]);

  useEffect(() => {
    //To insert the documents in filterDataWithDepartment array
    if (filterDataWithDepartment.length > 0) {
      const finalData = filterDataWithDepartment.map(item => {
        const item2 = fetchedFiles.find(value => {
          return (
            value.departmentId === item.DeptID &&
            value.index === item.EIndex &&
            value.siteId === item.SiteID
          );
        });
        return item2 ? { ...item, Doc: item2.documents } : item;
      });
      setFilterDataWithDepartment(finalData);
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchedFiles]);

  const commentOnChange = event => {
    const eventValue = event.target.value.trim();
    setComment(eventValue);
    const ValidationMessage = validateInputFields(eventValue, t);
    setInputValidationMessage(ValidationMessage);
  };
  const uniqueOwnerArray = findUnique(
    filterDataWithDepartment,
    key => key.OwnerEmail
  );

  const allDepartmentsForOwner = site => {
    const dupliacteDepartmentsArray = filterDataWithDepartment.filter(item => {
      return item.SiteName === site;
    });
    if (dupliacteDepartmentsArray.length === 1) {
      return keyMapper(dupliacteDepartmentsArray, 'Department')
        .toString()
        .split(',');
    } else if (dupliacteDepartmentsArray.length > 1) {
      const dupliacteOwnersArray = duplicates(
        dupliacteDepartmentsArray,
        key => key.OwnerEmail
      );
      return keyMapper(dupliacteOwnersArray, 'Department')
        .toString()
        .split(',');
    } else {
      return '';
    }
  };

  const allFactories = (data, key) => {
    return keyMapper(data, key).toString().split(',');
  };

  const rejectedAndSubmittedSites =
    globalData.length > 0 &&
    globalData[1].filter(item => {
      return (
        item.Status.includes('Reject') || item.Status.includes('Submitted')
      );
    });
  const rejectedSites =
    globalData.length > 0 &&
    globalData[1].filter(item => {
      return item.Status.includes('Reject');
    });
  const submittedSites =
    globalData.length > 0 &&
    globalData[1].filter(item => {
      return item.Status.includes('Submitted');
    });

  const onHoldSites =
    globalData.length > 0 &&
    globalData[1].filter(item => {
      return item.Status.includes('GC Hold');
    });

  const holdSites =
    globalData.length > 0 &&
    globalData[1].filter(item => {
      return item.Status.includes('Hold');
    });

  const hasAnyGCStatus =
    globalData.length > 0 &&
    globalData[1].some(item => {
      return item.Status.includes('GC');
    });

  const holdAndSubmittedSites =
    holdSites.length > 0 && submittedSites.length > 0;

  const filterDepartmentsForRejectedSites =
    filterDataWithDepartment.length > 0 &&
    filterDataWithDepartment.filter(value => {
      return value.GStatus.includes('Reject');
    });
  const rejectedSitesOwnerArray =
    filterDepartmentsForRejectedSites.length > 0 &&
    findUnique(filterDepartmentsForRejectedSites, key => key.OwnerEmail);

  const filterDepartmentsForSubmittedSites =
    filterDataWithDepartment.length > 0 &&
    filterDataWithDepartment.filter(value => {
      return (
        value.GStatus.includes('Submitted') &&
        value.DepartmentStatus.includes('Estimated')
      );
    });

  const submittedSitesOwnerArray =
    filterDepartmentsForSubmittedSites.length > 0 &&
    findUnique(filterDepartmentsForSubmittedSites, key => key.OwnerEmail);

  const filterDepartmentsForSubmittedAndRejectedSites =
    filterDataWithDepartment.length > 0 &&
    filterDataWithDepartment.filter(value => {
      return (
        (value.GStatus.includes('Submitted') ||
          value.GStatus.includes('Reject')) &&
        value.DepartmentStatus.includes('Estimated')
      );
    });

  const allDepartmentsForSubmittedSitesOwner = site => {
    const dupliacteDepartmentsArray = filterDataWithDepartment.filter(item => {
      return item.SiteName === site;
    });
    const dupliacteOwnersArray = duplicates(
      dupliacteDepartmentsArray,
      key => key.OwnerEmail
    );
    return keyMapper(dupliacteOwnersArray, 'Department').toString().split(',');
  };

  const onRejectClick = () => {
    return (
      //Updating the status of the sites
      (
        globalData.length > 0 &&
          globalData[1]
            .forEach(async siteInfo => {
              return await fetch(
                `${apiConfig.uiURL}api/UpdateGlobalCoordinatorReview`,
                {
                  method: 'PUT',
                  headers: APIHeader(),
                  body: JSON.stringify({
                    pecrId: siteInfo.PECRID,
                    siteId: siteInfo.SiteID,
                    Comments: comment,
                    StatusId: 14,
                    ButtonStatus: 1,
                  }),
                }
              );
            })
            .catch(() => {
              dispatch(
                errorNotification({
                  hasErrorOccured: true,
                  message: t('error_message'),
                })
              );
            }),
        //Send Email to creator
        fetch(`${apiConfig.uiURL}api/sendEmail`, {
          headers: APIHeader(),
          method: 'POST',
          body: JSON.stringify({
            toAddress:
              globalData[0] && globalData[0][0].CreatorEmail
                ? globalData[0][0].CreatorEmail
                : '',
            fromAddress: 'PECR@carrier.com',
            loginUserEmail: userInfo.userEmail,
            Title:
              globalData[0] && globalData[0][0].Title
                ? globalData[0][0].Title
                : '',
            PecrId: pecrId,
            type: 'assignEmail',
            toWhome: 'GC Reject',
            Comments: comment,
            Factory: allFactories(globalData[1], 'SiteName'),
            creatorsite:
              globalData[0] && globalData[0][0].CreatorSiteName
                ? globalData[0][0].CreatorSiteName
                : '',
            creator: `${
              globalData[0] && globalData[0][0].CreatorFirstName
                ? globalData[0][0].CreatorFirstName
                : ''
            } ${
              globalData[0] && globalData[0][0].CreatorLastName
                ? globalData[0][0].CreatorLastName
                : ''
            }`,
          }),
        }).catch(() => {
          dispatch(
            errorNotification({
              hasErrorOccured: true,
              message: t('error_message'),
            })
          );
        }),
        //Send Email to each departments' head
        filterDataWithDepartment.length > 0 &&
          filterDataWithDepartment.forEach(async siteInfo => {
            return fetch(`${apiConfig.uiURL}api/sendEmail`, {
              headers: APIHeader(),
              method: 'POST',
              body: JSON.stringify({
                toAddress: siteInfo.LeadEmail ? siteInfo.LeadEmail : '',
                fromAddress: 'PECR@carrier.com',
                loginUserEmail: userInfo.userEmail,
                Title: siteInfo.Title ? siteInfo.Title : '',
                PecrId: pecrId,
                type: 'assignEmail',
                toWhome: 'GC Reject DH',
                Departments: siteInfo.Department,
                Comments: comment,
                creatorsite: siteInfo.CreatorSiteName
                  ? siteInfo.CreatorSiteName
                  : '',
                creator: `${
                  siteInfo.CreatorFirstName ? siteInfo.CreatorFirstName : ''
                } ${siteInfo.CreatorLastName ? siteInfo.CreatorLastName : ''}`,
              }),
            }).catch(() => {
              dispatch(
                errorNotification({
                  hasErrorOccured: true,
                  message: t('error_message'),
                })
              );
            });
          }),
        //Send Email to each owner
        uniqueOwnerArray.length > 0 &&
          uniqueOwnerArray.forEach(async siteInfo => {
            return fetch(`${apiConfig.uiURL}api/sendEmail`, {
              headers: APIHeader(),
              method: 'POST',
              body: JSON.stringify({
                toAddress: siteInfo.OwnerEmail ? siteInfo.OwnerEmail : '',
                fromAddress: 'PECR@carrier.com',
                loginUserEmail: userInfo.userEmail,
                Title: siteInfo.Title ? siteInfo.Title : '',
                PecrId: pecrId,
                type: 'assignEmail',
                toWhome: 'GC Reject',
                Comments: comment,
                Factory: siteInfo.SiteName ? siteInfo.SiteName : '',
                creatorsite: siteInfo.CreatorSiteName
                  ? siteInfo.CreatorSiteName
                  : '',
                creator: `${
                  siteInfo.CreatorFirstName ? siteInfo.CreatorFirstName : ''
                } ${siteInfo.CreatorLastName ? siteInfo.CreatorLastName : ''}`,
              }),
            }).catch(() => {
              dispatch(
                errorNotification({
                  hasErrorOccured: true,
                  message: t('error_message'),
                })
              );
            });
          }),
        //Navigate to home page
        navigate('../')
      )
    );
  };

  const onHoldClick = () => {
    return (
      //Updating the status of the sites
      (
        submittedSites.length > 0 &&
          submittedSites.forEach(async siteInfo => {
            return await fetch(
              `${apiConfig.uiURL}api/UpdateGlobalCoordinatorReview`,
              {
                method: 'PUT',
                headers: APIHeader(),
                body: JSON.stringify({
                  pecrId: siteInfo.PECRID,
                  siteId: siteInfo.SiteID,
                  Comments: '',
                  StatusId: 9,
                  ButtonStatus: 2,
                  TargetDate: siteInfo.GCTargetDate || siteInfo.TargetDate,
                  CostImpact: siteInfo.CostImpactOnProducts,
                }),
              }
            ).catch(() => {
              dispatch(
                errorNotification({
                  hasErrorOccured: true,
                  message: t('error_message'),
                })
              );
            });
          }),
        //Navigate to home page
        navigate('../')
      )
    );
  };

  const onUnHoldClick = () => {
    return (
      //Updating the status of the sites
      (
        onHoldSites.length > 0 &&
          onHoldSites.forEach(async siteInfo => {
            return await fetch(
              `${apiConfig.uiURL}api/UpdateGlobalCoordinatorReview`,
              {
                method: 'PUT',
                headers: APIHeader(),
                body: JSON.stringify({
                  pecrId: siteInfo.PECRID,
                  siteId: siteInfo.SiteID,
                  Comments: comment,
                  StatusId: 9,
                  ButtonStatus: 2,
                  TargetDate: siteInfo.GCTargetDate || siteInfo.TargetDate,
                  CostImpact: siteInfo.CostImpactOnProducts,
                }),
              }
            ).catch(() => {
              dispatch(
                errorNotification({
                  hasErrorOccured: true,
                  message: t('error_message'),
                })
              );
            });
          }),
        //Navigate to home page
        navigate('../')
      )
    );
  };

  const onApproveSubmittedSitesClick = () => {
    return (
      //Updating the status of the rejected sites
      (
        rejectedSites.length > 0 &&
          rejectedSites.forEach(async siteInfo => {
            return await fetch(
              `${apiConfig.uiURL}api/UpdateGlobalCoordinatorReview`,
              {
                method: 'PUT',
                headers: APIHeader(),
                body: JSON.stringify({
                  pecrId: siteInfo.PECRID,
                  siteId: siteInfo.SiteID,
                  Comments: comment,
                  StatusId: 14,
                  ButtonStatus: 3,
                }),
              }
            ).catch(() => {
              dispatch(
                errorNotification({
                  hasErrorOccured: true,
                  message: t('error_message'),
                })
              );
            });
          }),
        //Send Email to creator for rejected sites
        rejectedSites.length > 0 &&
          fetch(`${apiConfig.uiURL}api/sendEmail`, {
            headers: APIHeader(),
            method: 'POST',
            body: JSON.stringify({
              toAddress:
                globalData[0] && globalData[0][0].CreatorEmail
                  ? globalData[0][0].CreatorEmail
                  : '',
              fromAddress: 'PECR@carrier.com',
              loginUserEmail: userInfo.userEmail,
              Title:
                globalData[0] && globalData[0][0].Title
                  ? globalData[0][0].Title
                  : '',
              PecrId: pecrId,
              type: 'assignEmail',
              toWhome: 'GC Reject',
              Comments: comment,
              Factory: allFactories(rejectedSites, 'SiteName'),
              creatorsite:
                globalData[0] && globalData[0][0].CreatorSiteName
                  ? globalData[0][0].CreatorSiteName
                  : '',
              creator: `${
                globalData[0] && globalData[0][0].CreatorFirstName
                  ? globalData[0][0].CreatorFirstName
                  : ''
              } ${
                globalData[0] && globalData[0][0].CreatorLastName
                  ? globalData[0][0].CreatorLastName
                  : ''
              }`,
            }),
          }).catch(() => {
            dispatch(
              errorNotification({
                hasErrorOccured: true,
                message: t('error_message'),
              })
            );
          }),
        //Send Email to each owner for rejected sites
        rejectedSitesOwnerArray.length > 0 &&
          rejectedSitesOwnerArray.forEach(async siteInfo => {
            return fetch(`${apiConfig.uiURL}api/sendEmail`, {
              headers: APIHeader(),
              method: 'POST',
              body: JSON.stringify({
                toAddress: siteInfo.OwnerEmail ? siteInfo.OwnerEmail : '',
                fromAddress: 'PECR@carrier.com',
                loginUserEmail: userInfo.userEmail,
                Title: siteInfo.Title ? siteInfo.Title : '',
                PecrId: pecrId,
                type: 'assignEmail',
                toWhome: 'GC Reject',
                Comments: comment,
                Factory: siteInfo.SiteName ? siteInfo.SiteName : '',
                creatorsite: siteInfo.CreatorSiteName
                  ? siteInfo.CreatorSiteName
                  : '',
                creator: `${
                  siteInfo.CreatorFirstName ? siteInfo.CreatorFirstName : ''
                } ${siteInfo.CreatorLastName ? siteInfo.CreatorLastName : ''}`,
              }),
            }).catch(() => {
              dispatch(
                errorNotification({
                  hasErrorOccured: true,
                  message: t('error_message'),
                })
              );
            });
          }),
        //Send Email to each departments' head for rejected sites
        filterDepartmentsForRejectedSites.length > 0 &&
          filterDepartmentsForRejectedSites.forEach(async siteInfo => {
            return fetch(`${apiConfig.uiURL}api/sendEmail`, {
              headers: APIHeader(),
              method: 'POST',
              body: JSON.stringify({
                toAddress: siteInfo.LeadEmail ? siteInfo.LeadEmail : '',
                fromAddress: 'PECR@carrier.com',
                loginUserEmail: userInfo.userEmail,
                Title: siteInfo.Title ? siteInfo.Title : '',
                PecrId: pecrId,
                type: 'assignEmail',
                toWhome: 'GC Reject DH',
                Comments: comment,
                Departments: siteInfo.Department,
                creatorsite: siteInfo.CreatorSiteName
                  ? siteInfo.CreatorSiteName
                  : '',
                creator: `${
                  siteInfo.CreatorFirstName ? siteInfo.CreatorFirstName : ''
                } ${siteInfo.CreatorLastName ? siteInfo.CreatorLastName : ''}`,
              }),
            }).catch(() => {
              dispatch(
                errorNotification({
                  hasErrorOccured: true,
                  message: t('error_message'),
                })
              );
            });
          }),
        //Updating the status of the submitted sites
        submittedSites.length > 0 &&
          submittedSites.forEach(async siteInfo => {
            return await fetch(
              `${apiConfig.uiURL}api/UpdateGlobalCoordinatorReview`,
              {
                method: 'PUT',
                headers: APIHeader(),
                body: JSON.stringify({
                  pecrId: siteInfo.PECRID,
                  siteId: siteInfo.SiteID,
                  Comments: comment,
                  StatusId: 12,
                  ButtonStatus: 3,
                  TargetDate: siteInfo.GCTargetDate || siteInfo.TargetDate,
                  CostImpact: siteInfo.CostImpactOnProducts,
                }),
              }
            ).catch(() => {
              dispatch(
                errorNotification({
                  hasErrorOccured: true,
                  message: t('error_message'),
                })
              );
            });
          }),
        //Send Email to creator for submitted sites
        submittedSites.length > 0 &&
          fetch(`${apiConfig.uiURL}api/sendEmail`, {
            headers: APIHeader(),
            method: 'POST',
            body: JSON.stringify({
              toAddress:
                globalData[0] && globalData[0][0].CreatorEmail
                  ? globalData[0][0].CreatorEmail
                  : '',
              fromAddress: 'PECR@carrier.com',
              loginUserEmail: userInfo.userEmail,
              Title:
                globalData[0] && globalData[0][0].Title
                  ? globalData[0][0].Title
                  : '',
              PecrId: pecrId,
              type: 'assignEmail',
              toWhome: 'GC All Sites Creator',
              Factory: allFactories(submittedSites, 'SiteName'),
              Comments: comment,
              creatorsite:
                globalData[0] && globalData[0][0].CreatorSiteName
                  ? globalData[0][0].CreatorSiteName
                  : '',
              creator: `${
                globalData[0] && globalData[0][0].CreatorFirstName
                  ? globalData[0][0].CreatorFirstName
                  : ''
              } ${
                globalData[0] && globalData[0][0].CreatorLastName
                  ? globalData[0][0].CreatorLastName
                  : ''
              }`,
            }),
          }).catch(() => {
            dispatch(
              errorNotification({
                hasErrorOccured: true,
                message: t('error_message'),
              })
            );
          }),
        //Send Email to each owner for submitted sites
        submittedSitesOwnerArray.length > 0 &&
          submittedSitesOwnerArray.forEach(async siteInfo => {
            return fetch(`${apiConfig.uiURL}api/sendEmail`, {
              headers: APIHeader(),
              method: 'POST',
              body: JSON.stringify({
                toAddress: siteInfo.OwnerEmail ? siteInfo.OwnerEmail : '',
                fromAddress: 'PECR@carrier.com',
                loginUserEmail: userInfo.userEmail,
                Title: siteInfo.Title ? siteInfo.Title : '',
                PecrId: pecrId,
                type: 'assignEmail',
                toWhome: 'GC All Sites Owner',
                Departments: allDepartmentsForSubmittedSitesOwner(
                  siteInfo.SiteName
                ),
                Comments: comment,
                Factory: siteInfo.SiteName ? siteInfo.SiteName : '',
                creatorsite: siteInfo.CreatorSiteName
                  ? siteInfo.CreatorSiteName
                  : '',
                creator: `${
                  siteInfo.CreatorFirstName ? siteInfo.CreatorFirstName : ''
                } ${siteInfo.CreatorLastName ? siteInfo.CreatorLastName : ''}`,
              }),
            }).catch(() => {
              dispatch(
                errorNotification({
                  hasErrorOccured: true,
                  message: t('error_message'),
                })
              );
            });
          }),
        //Send Email to each departments' head for submitted sites
        filterDepartmentsForSubmittedSites.length > 0 &&
          filterDepartmentsForSubmittedSites.forEach(async siteInfo => {
            return fetch(`${apiConfig.uiURL}api/sendEmail`, {
              headers: APIHeader(),
              method: 'POST',
              body: JSON.stringify({
                toAddress: siteInfo.LeadEmail ? siteInfo.LeadEmail : '',
                fromAddress: 'PECR@carrier.com',
                loginUserEmail: userInfo.userEmail,
                Title: siteInfo.Title ? siteInfo.Title : '',
                PecrId: pecrId,
                URL: `${url}ExecutionDepartment/${pecrId}/${siteInfo.SiteID}/${siteInfo.DeptID}/${siteInfo.EIndex}`,
                type: 'assignEmail',
                toWhome: 'GC All Sites DH',
                Comments: comment,
                Departments: siteInfo.Department ? siteInfo.Department : '',
                Factory: siteInfo.SiteName ? siteInfo.SiteName : '',
                creatorsite: siteInfo.CreatorSiteName
                  ? siteInfo.CreatorSiteName
                  : '',
                creator: `${
                  siteInfo.CreatorFirstName ? siteInfo.CreatorFirstName : ''
                } ${siteInfo.CreatorLastName ? siteInfo.CreatorLastName : ''}`,
              }),
            }).catch(() => {
              dispatch(
                errorNotification({
                  hasErrorOccured: true,
                  message: t('error_message'),
                })
              );
            });
          }),
        //Navigate to home page
        navigate('../')
      )
    );
  };

  const onApproveAllSitesClick = () => {
    return (
      //Updating the status of the sites
      (
        rejectedAndSubmittedSites.length > 0 &&
          rejectedAndSubmittedSites.forEach(async siteInfo => {
            return await fetch(
              `${apiConfig.uiURL}api/UpdateGlobalCoordinatorReview`,
              {
                method: 'PUT',
                headers: APIHeader(),
                body: JSON.stringify({
                  pecrId: siteInfo.PECRID,
                  siteId: siteInfo.SiteID,
                  Comments: comment,
                  StatusId: 12,
                  ButtonStatus: 4,
                  TargetDate: siteInfo.GCTargetDate || siteInfo.TargetDate,
                  CostImpact: siteInfo.CostImpactOnProducts,
                }),
              }
            ).catch(() => {
              dispatch(
                errorNotification({
                  hasErrorOccured: true,
                  message: t('error_message'),
                })
              );
            });
          }),
        //Send Email to creator
        fetch(`${apiConfig.uiURL}api/sendEmail`, {
          headers: APIHeader(),
          method: 'POST',
          body: JSON.stringify({
            toAddress:
              globalData[0] && globalData[0][0].CreatorEmail
                ? globalData[0][0].CreatorEmail
                : '',
            fromAddress: 'PECR@carrier.com',
            loginUserEmail: userInfo.userEmail,
            Title:
              globalData[0] && globalData[0][0].Title
                ? globalData[0][0].Title
                : '',
            PecrId: pecrId,
            type: 'assignEmail',
            toWhome: 'GC All Sites Creator',
            Comments: comment,
            Factory: allFactories(globalData[1], 'SiteName'),
            creatorsite:
              globalData[0] && globalData[0][0].CreatorSiteName
                ? globalData[0][0].CreatorSiteName
                : '',
            creator: `${
              globalData[0] && globalData[0][0].CreatorFirstName
                ? globalData[0][0].CreatorFirstName
                : ''
            } ${
              globalData[0] && globalData[0][0].CreatorLastName
                ? globalData[0][0].CreatorLastName
                : ''
            }`,
          }),
        }).catch(() => {
          dispatch(
            errorNotification({
              hasErrorOccured: true,
              message: t('error_message'),
            })
          );
        }),
        //Send Email to each owner
        uniqueOwnerArray.length > 0 &&
          uniqueOwnerArray.forEach(async siteInfo => {
            return fetch(`${apiConfig.uiURL}api/sendEmail`, {
              headers: APIHeader(),
              method: 'POST',
              body: JSON.stringify({
                toAddress: siteInfo.OwnerEmail ? siteInfo.OwnerEmail : '',
                fromAddress: 'PECR@carrier.com',
                loginUserEmail: userInfo.userEmail,
                Title: siteInfo.Title ? siteInfo.Title : '',
                PecrId: pecrId,
                type: 'assignEmail',
                Factory: siteInfo.SiteName ? siteInfo.SiteName : '',
                toWhome: 'GC All Sites Owner',
                Comments: comment,
                Departments: allDepartmentsForOwner(siteInfo.SiteName),
                creatorsite: siteInfo.CreatorSiteName
                  ? siteInfo.CreatorSiteName
                  : '',
                creator: `${
                  siteInfo.CreatorFirstName ? siteInfo.CreatorFirstName : ''
                } ${siteInfo.CreatorLastName ? siteInfo.CreatorLastName : ''}`,
              }),
            }).catch(() => {
              dispatch(
                errorNotification({
                  hasErrorOccured: true,
                  message: t('error_message'),
                })
              );
            });
          }),
        //Send Email to each departments' head
        filterDepartmentsForSubmittedAndRejectedSites.length > 0 &&
          filterDepartmentsForSubmittedAndRejectedSites.forEach(
            async siteInfo => {
              return fetch(`${apiConfig.uiURL}api/sendEmail`, {
                headers: APIHeader(),
                method: 'POST',
                body: JSON.stringify({
                  toAddress: siteInfo.LeadEmail ? siteInfo.LeadEmail : '',
                  fromAddress: 'PECR@carrier.com',
                  loginUserEmail: userInfo.userEmail,
                  Title: siteInfo.Title ? siteInfo.Title : '',
                  PecrId: pecrId,
                  URL: `${url}ExecutionDepartment/${pecrId}/${siteInfo.SiteID}/${siteInfo.DeptID}/${siteInfo.EIndex}`,
                  type: 'assignEmail',
                  toWhome: 'GC All Sites DH',
                  Comments: comment,
                  Departments: siteInfo.Department ? siteInfo.Department : '',
                  Factory: siteInfo.SiteName ? siteInfo.SiteName : '',
                  creatorsite: siteInfo.CreatorSiteName
                    ? siteInfo.CreatorSiteName
                    : '',
                  creator: `${
                    siteInfo.CreatorFirstName ? siteInfo.CreatorFirstName : ''
                  } ${siteInfo.CreatorLastName ? siteInfo.CreatorLastName : ''}`,
                }),
              }).catch(() => {
                dispatch(
                  errorNotification({
                    hasErrorOccured: true,
                    message: t('error_message'),
                  })
                );
              });
            }
          ),
        //Navigate to home page
        navigate('../')
      )
    );
  };

  //To handle the onClick of Save button
  const onSaveClick = () => {
    setShowSaveProgress(true);
    const updateData =
      globalData.length > 0 &&
      globalData[1].forEach(async siteInfo => {
        return await fetch(
          `${apiConfig.uiURL}api/UpdateGlobalCoordinatorReview`,
          {
            method: 'PUT',
            headers: APIHeader(),
            body: JSON.stringify({
              pecrId: siteInfo.PECRID,
              siteId: siteInfo.SiteID,
              Comments: comment,
              StatusId: 0,
              TargetDate: siteInfo.GCTargetDate || siteInfo.TargetDate,
              CostImpact: siteInfo.CostImpactOnProducts,
            }),
          }
        )
          .then(() => {
            setShowSaveProgress(false);
          })
          .catch(() => {
            setShowSaveProgress(false);
            dispatch(
              errorNotification({
                hasErrorOccured: true,
                message: t('error_message'),
              })
            );
          });
      });
    Promise.all([updateData])
      .then(() => {
        showToasterSuccess(t('Save_message'));
      })
      .catch(() => {
        showToasterFailure(t('Save_failed_message'));
      });
  };

  const onDateChange = (SiteName, event) => {
    // let newSelectedDate = [...selectedDate];
    // if (newSelectedDate.length > 0) {
    //   const newDateForSite = newSelectedDate.find(
    //     (item) => item.SiteName === SiteName
    //   );
    //   if (newDateForSite) {
    //     newDateForSite.pickedDate = event;
    //   } else {
    //     newSelectedDate = [
    //       ...selectedDate,
    //       {
    //         SiteName: SiteName,
    //         pickedDate: event,
    //       },
    //     ];
    //   }
    // } else {
    //   newSelectedDate = [
    //     {
    //       SiteName: SiteName,
    //       pickedDate: event,
    //     },
    //   ];
    // }
    // setSelectedDate(newSelectedDate);

    const newGlobalData = [...globalData];
    const dataToUpdateForSite = newGlobalData[1].find(value => {
      return value.SiteName === SiteName;
    });
    dataToUpdateForSite.GCTargetDate = event.format('MMM DD, YYYY');
    setGlobalData(newGlobalData);
  };

  //To download the files on DownloadFile API click
  const onDownloadFileClick = (siteId, departmentId, eIndex, filename) => {
    fetch(`${apiConfig.uiURL}api/DownloadFile`, {
      method: 'POST',
      headers: APIHeader(),
      body: JSON.stringify({
        MainFolder: 'PECROverview',
        SubFolder: pecrId,
        siteId: siteId,
        departmentId: departmentId,
        index: eIndex,
        filename: filename,
      }),
    })
      .then(async response => {
        response.blob().then(blob => {
          getDownloadLink(blob, filename);
        });
      })
      .catch(() => {
        dispatch(
          errorNotification({
            hasErrorOccured: true,
            message: t('error_message'),
          })
        );
      });
  };

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: '#1F305E',
      color: theme.palette.common.white,
      fontWeight: 'bold',
      fontSize: '17px',
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: '17px',
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(even)': {
      backgroundColor: theme.palette.action.hover,
    },
  }));

  let _3rdButton = false;
  if (!disabledButton || holdAndSubmittedSites) {
    _3rdButton = false;
  } else {
    _3rdButton = true;
  }

  return errorInAPI.hasErrorOccured ? (
    <ErrorAlert message={errorInAPI.message} />
  ) : globalData.length > 0 && userInfo && userInfo.userId !== '' ? (
    userInfo?.active?.toString() === '1' &&
    userInfo?.userId?.toString() !== '0' &&
    !isEmptyObject(GCValidUser) &&
    Number(userInfo?.userID) === Number(GCValidUser.GlobalCoordinator) &&
    userInfo?.userId !== null ? (
      <Grid>
        {disabled && !isHold && (
          <Grid style={ReviewDoneMessage}>
            {t('Review_is_already_completed')}
          </Grid>
        )}
        <Grid style={checkboxLabel} container spacing={2}>
          <Grid item xs={6}>
            <Grid style={SiteReviewTitle}>
              <h4 style={titleName}>{t('PECR_global_coordinator_review')}</h4>
            </Grid>
            <Grid style={SiteReviewTitle}>
              <Grid style={boldFont}>{t('Title')}:</Grid>
              <Grid style={GCValue}>
                {(globalData &&
                  globalData[0][0].Title &&
                  pecrId &&
                  `${globalData[0][0].Title}(${pecrId})`) ||
                  ''}
              </Grid>
            </Grid>
            <Grid style={SiteReviewTitle}>
              <Grid style={boldFont}>{t('Description')}:</Grid>
              <Grid style={GCValue}>
                {(globalData && globalData[0][0].Description) || ''}
              </Grid>
            </Grid>
            <Grid style={SiteReviewTitle}>
              <Grid style={boldFont}>{t('Product_Family')}:</Grid>
              <Grid style={SiteReviewValue} width={700}>
                {(globalData &&
                  globalData[0][0].ProductFamily &&
                  globalData[0][0].ProductFamily.split(',').join(', ')) ||
                  ''}
              </Grid>
            </Grid>
            <Grid style={SiteReviewTitle}>
              <Grid style={boldFont}>{t('Creator')}:</Grid>
              <Grid style={SiteReviewValue}>
                {(globalData &&
                  globalData[0][0].CreatorFirstName &&
                  globalData[0][0].CreatorLastName &&
                  globalData[0][0].CreatorSiteName &&
                  `${globalData[0][0].CreatorFirstName}
                 ${globalData[0][0].CreatorLastName} (${globalData[0][0].CreatorSiteName})`) ||
                  ''}
              </Grid>
            </Grid>
          </Grid>
          <Grid style={GlobalSiteTable} item xs={6}>
            <TableContainer component={Paper}>
              <Table aria-label="customized table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="center" width={200}>
                      {t('Sites_Impacted')}
                    </StyledTableCell>
                    <StyledTableCell align="center" width={300}>
                      {t('Status')}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {t('Total_Effort_Hours')}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {t('Total_Costs_Currency')}
                    </StyledTableCell>
                    <StyledTableCell align="center" width={200}>
                      {t('Target_date_for_execution')}
                    </StyledTableCell>
                    <StyledTableCell align="center" width={5}></StyledTableCell>
                    <StyledTableCell align="center" width={200}>
                      {t('Cost_impact_on_products')}
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {globalData[1].map((data, index) => (
                    <StyledTableRow key={index}>
                      <StyledTableCell align="center">
                        {data && data.SiteName ? data.SiteName : ''}
                      </StyledTableCell>
                      <StyledTableCell align="center" width={400}>
                        {data && data.Status ? data.Status : ''}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {(data && data.TotalEffort) ||
                        (data && data.TotalEffort === 0)
                          ? data.TotalEffort
                          : ''}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {`${
                          (data && data.TotalCost) ||
                          (data && data.TotalCost === 0)
                            ? data.TotalCost
                            : ''
                        } ${
                          data && data.TotalCost && data.Currency
                            ? data.Currency
                            : ''
                        }`}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {data.Status.includes('Reject') ||
                        data.Status.includes('NotImpacted') ||
                        (data.Status !== 'Submitted' &&
                          !data.Status.includes('GC')) ? (
                          ''
                        ) : (
                          <PickDate
                            value={
                              data && data.GCTargetDate
                                ? data.GCTargetDate
                                : data.TargetDate
                            }
                            disabled={data.Status.includes('GC')}
                            setValue={event =>
                              onDateChange(data.SiteName, event)
                            }
                          />
                        )}
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        width={5}
                      ></StyledTableCell>
                      <StyledTableCell align="center" width={200}>
                        <InputTextField
                          name={'CostImpactValue'}
                          placeholder={t('Cost')}
                          style={{
                            border: '1px solid black',
                            padding: '0px 5px',
                            borderRadius: '5px 0px 0px  5px ',
                          }}
                          value={data.CostImpactOnProducts}
                          onBlur={event =>
                            setGlobalData(prevState => {
                              const newGlobalData = [...prevState];
                              newGlobalData[1][index]['CostImpactOnProducts'] =
                                event.target.value;
                              return newGlobalData;
                            })
                          }
                          readOnly
                          type={'number'}
                          disabled={disabled || hasAnyGCStatus}
                          onKeyDown={e =>
                            includeNegativeForCostImpact.includes(e.key) &&
                            e.preventDefault()
                          }
                        />
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>

        <Grid style={SiteReviewTitle}>
          <TableContainer component={Paper}>
            <Table aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell align="center">{t('Site')}</StyledTableCell>
                  <StyledTableCell align="center">
                    {t('Department')}
                  </StyledTableCell>
                  <StyledTableCell align="center">{t('Lead')}</StyledTableCell>
                  <StyledTableCell align="center">{t('Date')}</StyledTableCell>
                  <StyledTableCell align="center" width={10}>
                    {t('Effort_Hours')}
                  </StyledTableCell>
                  <StyledTableCell align="center" width={10}>
                    {t('Costs_Currency')}
                  </StyledTableCell>
                  <StyledTableCell align="center" width={20}>
                    {t('Comments')}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {t('Attachements')}
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filterDataWithDepartment.map((data, index) => (
                  <StyledTableRow key={index}>
                    <StyledTableCell align="center">
                      {data && data.SiteName ? data.SiteName : ''}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {data && data.Department ? data.Department : ''}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {`${
                        data && data.LeadFirstName ? data.LeadFirstName : ''
                      } ${data && data.LeadLastName ? data.LeadLastName : ''}`}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {data && data.EstimatedDate ? data.EstimatedDate : ''}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {(data && data.EstimatedEffort) ||
                      (data && data.EstimatedEffort === 0)
                        ? data.EstimatedEffort
                        : ''}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {`${
                        (data && data.EstimatedCost) ||
                        (data && data.EstimatedCost === 0)
                          ? data.EstimatedCost
                          : ''
                      } ${data && data.CurrencyUnit ? data.CurrencyUnit : ''}`}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <Tooltip
                        title={
                          data && data.EstimatedComment
                            ? data.EstimatedComment
                            : ''
                        }
                        componentsProps={{
                          tooltip: {
                            sx: {
                              fontSize: '14px',
                            },
                          },
                        }}
                      >
                        <Typography
                          noWrap
                          width={300}
                          sx={{
                            cursor: 'default',
                            margin: 'auto',
                            fontSize: '14px',
                            maxHeight: '100px',
                            overflow: 'auto',
                            wordWrap: 'break-word',
                            whiteSpace: 'pre-wrap',
                            '&::-webkit-scrollbar': {
                              width: '6px',
                            },
                            '&::-webkit-scrollbar-track': {
                              backgroundColor: '#f1f1f1',
                              borderRadius: '10px',
                            },
                            '&::-webkit-scrollbar-thumb': {
                              backgroundColor: '#c1c1c1',
                              borderRadius: '10px',
                            },
                            '&::-webkit-scrollbar-thumb:hover': {
                              backgroundColor: '#a8a8a8',
                            },
                          }}
                        >
                          {data && data.EstimatedComment
                            ? data.EstimatedComment
                            : ''}
                        </Typography>
                      </Tooltip>
                    </StyledTableCell>
                    <StyledTableCell align="center" width={100}>
                      {data && data.Doc && data.Doc.length > 0
                        ? data.Doc.map((document, id) => {
                            return (
                              <Tooltip
                                key={id}
                                title={document}
                                componentsProps={{
                                  tooltip: {
                                    sx: {
                                      fontSize: '14px',
                                    },
                                  },
                                }}
                              >
                                <Typography
                                  key={id}
                                  noWrap
                                  width={300}
                                  style={TextAsLink}
                                  onClick={() =>
                                    onDownloadFileClick(
                                      data.SiteID,
                                      data.DeptID,
                                      data.EIndex,
                                      document
                                    )
                                  }
                                >
                                  {document}
                                </Typography>
                              </Tooltip>
                            );
                          })
                        : ''}
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        <Grid style={OwnerLSCComment}>
          <InputTextAreaField
            name={'LCRComment'}
            placeholder={t('Add_Comments_here')}
            onChange={commentOnChange}
            customStyle={commentStyle}
            value={comment}
            disabled={disabled}
          />
        </Grid>
        <Grid style={validationErrorOnPages}>{inputValidationMessage}</Grid>
        <Toast />
        <Grid style={LocalSiteButtons}>
          <Button
            title={t('Reject')}
            onClick={onRejectClick}
            disabled={
              disabled ||
              disableRejectHold ||
              comment === null ||
              comment === '' ||
              inputValidationMessage !== ''
            }
          />
          {isHold ? (
            <Button title={t('Un_Hold')} onClick={onUnHoldClick} />
          ) : (
            <Button
              title={t('Hold')}
              onClick={onHoldClick}
              disabled={
                disabled ||
                disableRejectHold ||
                comment === null ||
                comment === '' ||
                inputValidationMessage !== ''
              }
            />
          )}
          <Grid sx={{ position: 'relative' }}>
            <Button
              title={t('Save')}
              onClick={onSaveClick}
              disabled={
                disabled || inputValidationMessage !== '' || showSaveProgress
              }
            />
            {showSaveProgress && (
              <CircularProgress size={28} sx={buttonCircularProgress} />
            )}
          </Grid>
          <Button
            title={t('Approve_for_execution_for_submitted_sites_only')}
            onClick={onApproveSubmittedSitesClick}
            disabled={_3rdButton || inputValidationMessage !== ''}
          />
          <Button
            title={t('Approve_for_execution_all_sites')}
            onClick={onApproveAllSitesClick}
            disabled={
              disabled || disabledButton || inputValidationMessage !== ''
            }
          />
        </Grid>
      </Grid>
    ) : (
      <Grid style={homeButtonComponent}>{t('No_active_user_message')}</Grid>
    )
  ) : (
    <Grid style={homeButtonComponent}>
      <CircularProgress />
    </Grid>
  );
};

const mapStateToProps = (state = {}) => {
  return {
    userInfo: state.userInfo,
    errorInAPI: state.errorNotification,
  };
};

export default connect(mapStateToProps, null)(GlobalCoordinatorReview);
